import { render, staticRenderFns } from "./TextTag.vue?vue&type=template&id=e97d54e6"
import script from "./TextTag.vue?vue&type=script&lang=js"
export * from "./TextTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports